/* ==========================================================================
   NGM PERFORMANCE CONFIGURATOR — Logik  (v4.5)
   --------------------------------------------------------------------------
   Gehoert zu: sections/ngm-performance-configurator.liquid
   Ausgelagert aus dem frueheren Custom-Liquid-Block, weil der bei 50 KB
   endet und v44 mit 60 KB nicht mehr hineinpasste.

   Diese Datei enthaelt KEIN Liquid und darf keins enthalten — Shopify
   rendert Assets nicht durch die Template-Engine.
   Alles Shop-Abhaengige kommt aus drei JSON-Bloecken in der Section:
     #v-shop-config    Waehrungen (shop.currency / cart.currency.iso_code)
     #v-data-final     Fahrzeuge aus dem Metaobjekt vehicle_config
     #v-variants-data  Varianten des aktuellen Produkts

   Sprache: /de im Pfad = Deutsch (NC_T + ncApplyLang). Bewusst NICHT ueber
   request.locale — das liefert im Weglot-Setup immer 'en'.

   WICHTIG — Einbindung ohne defer:
   Das Script haengt einen submit-Listener in der CAPTURE-Phase an document,
   genau wie der Cart-Drawer, und der ruft dort stopImmediatePropagation().
   Capture-Listener feuern in Registrierungsreihenfolge. Mit defer liefe
   diese Datei erst nach dem Parsen und damit NACH dem Drawer — der wuerde
   das submit-Event schlucken, bevor syncProps() das Fahrzeug ins Formular
   schreibt. Ausserdem setzt ncApplyLang() die deutschen Labels synchron;
   mit defer koennte auf /de kurz "Brand" statt "Marke" aufblitzen.
   Deshalb: <script src="..."></script> an derselben Stelle wie frueher der
   Inline-Block. Die Datei wird vom Browser gecacht, das Blockieren kostet
   ab dem zweiten Seitenaufruf nichts mehr.
   ========================================================================== */

(function() {
 'use strict';
 var root = document.getElementById('ngm-v-restore-root');
 if (!root) return;
 /* ═══════════════════════════════════════════════════════════════════════
    SPRACHE (v4.4)
    ───────────────────────────────────────────────────────────────────────
    request.locale.iso_code liefert im Weglot-Setup IMMER 'en'. Die Labels
    dürfen deshalb nicht aus Liquid kommen — sonst rendert der Shop englisch
    und Weglot übersetzt im Frontend mit eigenen Formulierungen nach
    ("Jahr" statt "Baujahr", Siezen statt Duzen) und lässt Wörter wie
    "Brand" ganz stehen.
    Erkennung wie im Cart-Drawer v4.5: /de im Pfad = Deutsch.
    Alle Texte tragen data-wg-notranslate, Weglot fasst sie nicht mehr an.
    ═══════════════════════════════════════════════════════════════════════ */
 var _ngmIsDE = /^\/de(\/|$)/.test(window.location.pathname || '/');
 var NC_LANG = _ngmIsDE ? 'de' : 'en';

 var NC_T = {
  brand:            { de: 'Marke',            en: 'Brand' },
  model:            { de: 'Modell',           en: 'Model' },
  engine:           { de: 'Motor',            en: 'Engine' },
  year:             { de: 'Baujahr',          en: 'Year' },
  select:           { de: 'Fahrzeug wählen',  en: 'Select your vehicle' },
  addcart:          { de: 'In den Warenkorb', en: 'Add to Cart' },
  added:            { de: 'Hinzugefügt ✓',    en: 'Added ✓' },
  showall:          { de: 'Alle anzeigen',    en: 'Show all' },
  showless:         { de: 'Weniger anzeigen', en: 'Show less' },
  active:           { de: 'Aktiv',            en: 'Active' },
  activeprotocols:  { de: 'Aktive Protokolle', en: 'Active Protocols' },
  notice:           { de: 'Hinweis',          en: 'Notice' },
  cta_eyebrow:      { de: 'Bereit für dein Fahrzeug', en: 'Ready for your car' },
  stock:            { de: 'Serie',            en: 'Stock' },
  count:            { de: 'aktiv',            en: 'active' },
  pleaseselect:     { de: 'Bitte wähle zuerst dein Fahrzeug.', en: 'Please select your vehicle first.' },
  pricena:          { de: 'Preis n.v.',       en: 'Price N/A' },
  error:            { de: 'Fehler – erneut versuchen', en: 'Error – retry' },
  novariant:        { de: 'Keine passende Variante für', en: 'No matching variant for' },
  critical:         { de: 'Wichtiger Hinweis', en: 'Important Notice' },
  critical_btn:     { de: 'Mehr erfahren',    en: 'Learn more' },
  play:             { de: 'Video abspielen',  en: 'Play video' },
  chart_title:      { de: 'Leistungsdiagramm', en: 'Power chart' },
  both:             { de: 'Beide',            en: 'Both' },
  power:            { de: 'Leistung',         en: 'Power' },
  torque:           { de: 'Drehmoment',       en: 'Torque' },
  rpm_short:        { de: 'U/min',            en: 'rpm' },
  rpm_axis:         { de: 'U/MIN',            en: 'RPM' },
  disc_pre:         { de: 'Diese Leistungswerte werden ausschließlich unter optimalen Betriebsbedingungen und mit mindestens',
                      en: 'These performance figures are only achieved under optimal operating conditions and with a minimum of' },
  disc_octane:      { de: '102 ROZ',          en: '102 RON' },
  disc_post:        { de: 'Kraftstoff erreicht. Mit geringwertigerem Kraftstoff sind diese Werte nicht erreichbar.',
                      en: 'fuel. Lower-octane fuel will not deliver these results.' }
 };

 /* Ein Text in aktueller Sprache */
 function T(key) {
  var e = NC_T[key];
  return (e && (e[NC_LANG] || e.en)) || '';
 }

 /* L bleibt als Kurzform erhalten, wird aber aus NC_T gebaut statt aus Liquid */
 var L = {};
 for (var _k in NC_T) { L[_k] = T(_k); }

 /* Statische Markup-Texte setzen. Läuft synchron direkt nach dem Markup,
    also vor dem ersten Paint -> kein sichtbares Umspringen.

    Zwei Quellen:
    a) data-ngm-l10n="key"  -> fester Text aus NC_T (Labels der Bedienelemente)
    b) data-ngm-de / data-ngm-en -> frei eingetippter Text aus den Section-
       Einstellungen (Überschrift, Untertitel). Muss über Attribute laufen,
       weil request.locale im Weglot-Setup immer 'en' liefert und Liquid die
       Sprache damit nicht kennt. Ist ein Feld leer, gewinnt das gefüllte —
       so muss niemand beide Sprachen pflegen. */
 function ncApplyLang() {
  /* v4.7.1: Die Sticky-Leiste liegt seit dem Umzug aus .nc-band ausserhalb
     von root und wuerde von einer reinen root-Suche nicht mehr erfasst.
     Ihre Beschriftung setzt zwar auch ncEachAtc() bei jeder Fahrzeugwahl —
     aber sich darauf zu verlassen waere unnoetig zerbrechlich. */
  var l10nScopes = [root];
  var stickyBar = document.getElementById('v-sticky');
  if (stickyBar && !root.contains(stickyBar)) l10nScopes.push(stickyBar);
  l10nScopes.forEach(function(scope) {
   scope.querySelectorAll('[data-ngm-l10n]').forEach(function(el) {
    var t = T(el.getAttribute('data-ngm-l10n'));
    if (t && el.textContent !== t) el.textContent = t;
   });
  });
  root.querySelectorAll('[data-ngm-de],[data-ngm-en]').forEach(function(el) {
   var de = el.getAttribute('data-ngm-de') || '';
   var en = el.getAttribute('data-ngm-en') || '';
   var t  = NC_LANG === 'de' ? (de || en) : (en || de);
   if (el.textContent !== t) el.textContent = t;
   /* Beide Felder leer -> Zeile ausblenden statt leeren Platz zu lassen */
   el.hidden = !t;
  });
 }
 ncApplyLang();

 /* ═══════════════════════════════════════════════════════════════════════
    WÄHRUNG
    ───────────────────────────────────────────────────────────────────────
    NC_BASE_CUR   = Shop-Hauptwährung. In dieser Währung stehen die
                    Metaobjekt-Cents (currentV.p).
    NC_ACTIVE_CUR = Währung, die der Besucher gerade sieht.
    NC_FX         = Kurs Shop-Währung -> aktive Währung, den das Theme
                    selbst ins Frontend schreibt.
    NC_IS_BASE    = true, solange keine Umrechnung stattfindet.

    Wichtig: variant.price kommt aus Liquid und ist von Shopify Markets
    BEREITS umgerechnet — currentV.p dagegen nicht. Die beiden dürfen
    deshalb nur verglichen werden, wenn NC_IS_BASE gilt.
    ═══════════════════════════════════════════════════════════════════════ */
 /* v4.5: kommt jetzt aus <script id="v-shop-config"> in der Section,
    damit diese Datei reines JavaScript ohne Liquid bleibt. */
 var NC_CFG = {};
 try { NC_CFG = JSON.parse(document.getElementById('v-shop-config').textContent || '{}'); }
 catch (e) { console.error('[NGM Config] shop-config parse failed:', e); }
 var NC_BASE_CUR   = NC_CFG.base_currency || 'EUR';
 var NC_ACTIVE_CUR = NC_CFG.active_currency || NC_BASE_CUR;
 var NC_IS_BASE    = (NC_ACTIVE_CUR === NC_BASE_CUR);
 var NC_FX = parseFloat((window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || '1');
 if (!isFinite(NC_FX) || NC_FX <= 0) NC_FX = 1;
 var NC_LOCALE = _ngmIsDE ? 'de-DE' : 'en-US';

 /* Cents in AKTIVER Währung -> "699,00 €" bzw. "€699.00" */
 function ncFmt(cents) {
  var amount = (Number(cents) || 0) / 100;
  try {
   return new Intl.NumberFormat(NC_LOCALE, { style: 'currency', currency: NC_ACTIVE_CUR }).format(amount);
  } catch (e) {
   return amount.toFixed(2) + ' ' + NC_ACTIVE_CUR;
  }
 }
 /* Cents in SHOP-Währung -> umgerechnet und formatiert (nur als Näherung,
    wenn keine Variante gefunden wurde) */
 function ncFmtConverted(cents) {
  return ncFmt(Math.round((Number(cents) || 0) * NC_FX));
 }

 /* v4.4: der frühere _ngmIsDE-Block, der v-critical-label, v-critical-btn-label,
    L.critical_btn und L.play einzeln nachgezogen hat, ist entfallen —
    ncApplyLang() und L aus NC_T decken das jetzt vollständig ab. */
 var CRITICAL_DEFAULTS = _ngmIsDE ? {
  "cupra|formentor vz5": "Der Cupra Formentor VZ5 erfordert einen Unlock der Motorsteuerung (ECU), bevor das Tuning durchgeführt werden kann. Die ECU muss dafür zur Firma Autotuner geschickt werden, um entsperrt zu werden. Ohne diesen Unlock ist ein NGM App Tuning leider nicht möglich. Weitere Informationen zum Unlock findest du hier: https://www.autotuner.com/de/products/unlock-vag-mg1cs163",
  "audi|rs3 8y": "Der Audi RS3 8Y erfordert einen Unlock der Motorsteuerung (ECU), bevor das Tuning durchgeführt werden kann. Die ECU muss dafür zur Firma Autotuner geschickt werden, um entsperrt zu werden. Ohne diesen Unlock ist ein NGM App Tuning leider nicht möglich. Weitere Informationen zum Unlock findest du hier: https://www.autotuner.com/de/products/unlock-vag-mg1cs163"
 } : {
  "cupra|formentor vz5": "The Cupra Formentor VZ5 requires an unlock of the engine control unit (ECU) before tuning can be performed. The ECU must be sent to the company Autotuner to be unlocked. Without this unlock, NGM app tuning is unfortunately not possible. More information about the unlock can be found here: https://www.autotuner.com/de/products/unlock-vag-mg1cs163",
  "audi|rs3 8y": "The Audi RS3 8Y requires an unlock of the engine control unit (ECU) before tuning can be performed. The ECU must be sent to the company Autotuner to be unlocked. Without this unlock, NGM app tuning is unfortunately not possible. More information about the unlock can be found here: https://www.autotuner.com/de/products/unlock-vag-mg1cs163"
 };
 function getCritical(brand, model) {
  if (!brand || !model) return "";
  var b = String(brand).toLowerCase().trim(), m = String(model).toLowerCase().trim();
  for (var k in CRITICAL_DEFAULTS) { var p = k.split("|"); if (b.indexOf(p[0]) !== -1 && m.indexOf(p[1]) !== -1) return CRITICAL_DEFAULTS[k]; }
  return "";
 }
 window.__NGM_CONFIGURATOR = { active: false, variantId: null, vehicle: '', lic: '' };
 var data = [];
 try { data = JSON.parse(document.getElementById('v-data-final').textContent || "[]"); } catch(e) { console.error("Data error", e); }
 var allVariants = [];
 try { allVariants = JSON.parse(document.getElementById('v-variants-data').textContent || "[]"); } catch(e) { console.error("Variants error", e); }
 var bS = document.getElementById('f-brand'), mS = document.getElementById('f-model'), eS = document.getElementById('f-engine'), yS = document.getElementById('f-year'), atcBtn = document.getElementById('nc-atc-btn');
 /* v4.6: Es gibt jetzt ZWEI Kaufbuttons — den in der Fahrzeugleiste oben und
    den grossen Abschluss-CTA unten. Beide muessen immer denselben Zustand
    tragen (Variante, Beschriftung, disabled), sonst kauft der eine, waehrend
    der andere noch "Preis n.v." zeigt. atcBtn bleibt der Primaere: an ihm
    haengen syncGlobalState() und das Highlight aus autoPrefill().
    querySelectorAll findet beide, weil sie im Section-Markup stehen und
    dieses Script ohne defer laeuft — das DOM davor ist bereits geparst. */
 var atcBtns = Array.prototype.slice.call(document.querySelectorAll('.nc-atc-btn'));
 function ncEachAtc(fn) { atcBtns.forEach(fn); }

 /* ═══════════════════════════════════════════════════════════════════════
    STICKY-KAUFLEISTE (v4.7.1) — nur Handy
    ───────────────────────────────────────────────────────────────────────
    Sichtbar, sobald ein Fahrzeug gewaehlt ist UND die obere Fahrzeugleiste
    nicht mehr im Bild steht. Sonst zeigen beide gleichzeitig denselben
    Preis und denselben Kaufbutton — das sah aus wie ein Fehler.

    Gemessen wird bei jedem Scroll frisch ueber getBoundingClientRect(),
    gedrosselt mit requestAnimationFrame (hoechstens einmal pro Bildaufbau).
    Bewusst KEIN IntersectionObserver: der meldet nur Zustandswechsel. Beim
    Scrollen durch einen langen Bereich, in dem sich am Sichtbarkeitsstatus
    nichts aendert, kaeme kein Callback — die Leiste bliebe haengen.

    Die Klasse am <body> gleicht die Hoehe der Leiste aus, damit sie die
    letzten ~70px der Seite nicht verdeckt. Sie sitzt am <body>, weil der
    Seitenfuss ausserhalb des Konfigurators liegt; die Regel dazu greift
    nur unter 749px.
    ═══════════════════════════════════════════════════════════════════════ */
 var ncStickyApply = function () {};
 (function ncStickyInit() {
  var bar = document.getElementById('v-sticky');
  if (!bar) return;
  var info = document.getElementById('v-info-bar');

  ncStickyApply = function () {
   var on = false;
   if (currentV) {
    var vh = window.innerHeight || document.documentElement.clientHeight || 0;
    var ir = info ? info.getBoundingClientRect() : null;
    /* Ausgeblendete Elemente liefern lauter Nullen — height mitpruefen,
       sonst gilt die versteckte Leiste faelschlich als "im Bild". */
    var infoVisible = !!(ir && ir.height && ir.bottom > 0 && ir.top < vh);
    on = !infoVisible;
   }
   bar.classList.toggle('nc-hide', !on);
   bar.setAttribute('aria-hidden', on ? 'false' : 'true');
   if (document.body) document.body.classList.toggle('nc-has-sticky', on);
  };

  var ticking = false;
  function onScroll() {
   if (ticking) return;
   ticking = true;
   requestAnimationFrame(function () { ticking = false; ncStickyApply(); });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
 })();
 var currentV = null, activeMode = "both";
 /* v4.4: defaultVariantId entfernt — war deklariert, wurde nie gelesen.
    Die Varianten-ID kommt ausschließlich aus findVariantByPrice(). */

 /* ===== NGM Dyno-Chart Renderer v3.1 (realistic, responsive, mobile-stable) ===== */
 var NC_STATE=null, NC_AMP=0.009, NC_RZ=null, NC_BP=null;
 var NC_PSHAPE=[[0,.10],[.08,.17],[.16,.27],[.26,.40],[.37,.55],[.48,.69],[.58,.81],[.68,.90],[.78,.97],[.86,1],[.93,.985],[1,.91]];
 var NC_TSHAPE=[[0,.42],[.07,.60],[.13,.80],[.20,.95],[.27,1],[.40,1],[.50,.99],[.60,.95],[.70,.89],[.80,.80],[.90,.68],[1,.56]];
 function ncRip(t,s){return Math.sin(t*58+s*1.7)*0.5+Math.sin(t*142+s*0.6+1.1)*0.32+Math.sin(t*300+s*2.3)*0.16;}
 function ncEl(t,a){var e=document.createElementNS('http://www.w3.org/2000/svg',t);for(var k in a)e.setAttribute(k,a[k]);return e;}
 function ncHexA(h,a){var n=parseInt(h.slice(1),16);return'rgba('+(n>>16&255)+','+(n>>8&255)+','+(n&255)+','+a+')';}
 function ncFrac(sh,t){for(var i=0;i<sh.length-1;i++){if(t>=sh[i][0]&&t<=sh[i+1][0]){var a=sh[i],b=sh[i+1];return a[1]+(b[1]-a[1])*(t-a[0])/(b[0]-a[0]);}}return sh[sh.length-1][1];}
 function ncSmooth(p){if(p.length<2)return'';var d='M'+p[0][0].toFixed(1)+','+p[0][1].toFixed(1);for(var i=0;i<p.length-1;i++){var a=p[i-1]||p[i],b=p[i],c=p[i+1],e=p[i+2]||c,c1x=b[0]+(c[0]-a[0])/6,c1y=b[1]+(c[1]-a[1])/6,c2x=c[0]-(e[0]-b[0])/6,c2y=c[1]-(e[1]-b[1])/6;d+=' C'+c1x.toFixed(1)+','+c1y.toFixed(1)+' '+c2x.toFixed(1)+','+c2y.toFixed(1)+' '+c[0].toFixed(1)+','+c[1].toFixed(1);}return d;}
 function ncIsMobile(){var sv=document.getElementById('nc-cv-svg');var w=(sv&&sv.parentNode)?sv.parentNode.clientWidth:700;return w<560;}
 function ncGeo(){if(ncIsMobile())return{W:432,H:362,x0:46,x1:386,yT:34,yB:300,xt:[0,2,4,6],fs:8.5,cap:9};return{W:920,H:380,x0:66,x1:854,yT:40,yB:304,xt:[0,1,2,3,4,5,6],fs:10,cap:10};}
 function ncSeries(v){return [{l:T('stock'),c:'#aeb4be',pg:'#8b93a0',bar:'#8b93a0',dim:true,seed:4,ps:Math.max(v.s_ps,v.s_ps_to),nm:Math.max(v.s_nm,v.s_nm_to)},{l:'Stage 1',c:'#3da0ff',pg:'url(#nc-gB)',bar:'#3da0ff',seed:9,ps:v.s1_ps,nm:v.s1_nm},{l:'Stage 2',c:'#34f06a',pg:'url(#nc-gG)',bar:'#34f06a',hl:true,seed:14,ps:v.s2_ps,nm:v.s2_nm}];}
 function clearChart(){['nc-cv-grid','nc-cv-axis','grp-power','grp-torque','nc-cv-peaks','nc-cv-hover'].forEach(function(id){var e=document.getElementById(id);if(e)e.innerHTML='';});['nc-legend','nc-stats-row'].forEach(function(id){var e=document.getElementById(id);if(e){e.innerHTML='';e.classList.add('nc-hide');}});var c=document.getElementById('nc-cv-clip-rect');if(c)c.setAttribute('width',0);NC_STATE=null;}
 function ncReveal(animate){var c=document.getElementById('nc-cv-clip-rect'),pk=document.getElementById('nc-cv-peaks');if(!c||!NC_STATE)return;var W=NC_STATE.pW;if(!animate||!window.requestAnimationFrame){c.setAttribute('width',W);if(pk)pk.style.opacity=1;return;}if(pk)pk.style.opacity=0;var st=null;c.setAttribute('width',0);function f(ts){if(st===null)st=ts;var k=Math.min(1,(ts-st)/850);c.setAttribute('width',(W*(1-Math.pow(1-k,3))).toFixed(1));if(k<1){requestAnimationFrame(f);}else{c.setAttribute('width',W);if(pk)pk.style.opacity=1;}}requestAnimationFrame(f);}
 function ncBuildLegend(){var lg=document.getElementById('nc-legend');if(!lg)return;lg.classList.remove('nc-hide');lg.innerHTML='';[[T('stock'),'#8b93a0'],['Stage 1','#3da0ff'],['Stage 2','#34f06a']].forEach(function(s){var c=document.createElement('span');c.className='chip';c.innerHTML='<span class="dot" style="background:'+s[1]+'"></span>'+s[0];lg.appendChild(c);});var sp=document.createElement('span');sp.className='sep';lg.appendChild(sp);var l1=document.createElement('span');l1.className='chip';l1.innerHTML='<svg width="20" height="6"><line x1="0" y1="3" x2="20" y2="3" stroke="rgba(255,255,255,.6)" stroke-width="2.4"/></svg>'+T('power');lg.appendChild(l1);var l2=document.createElement('span');l2.className='chip';l2.innerHTML='<svg width="20" height="6"><line x1="0" y1="3" x2="20" y2="3" stroke="rgba(255,255,255,.6)" stroke-width="2" stroke-dasharray="4,3"/></svg>'+T('torque');lg.appendChild(l2);}
 function ncBuildRows(v){var box=document.getElementById('nc-stats-row');if(!box)return;box.classList.remove('nc-hide');box.innerHTML='';var sp=Math.max(v.s_ps,v.s_ps_to),sn=Math.max(v.s_nm,v.s_nm_to);[{l:T('stock'),ps:sp,nm:sn,c:'#aeb4be',bar:'#8b93a0',dim:1},{l:'Stage 1',ps:v.s1_ps,nm:v.s1_nm,c:'#3da0ff',bar:'#3da0ff'},{l:'Stage 2',ps:v.s2_ps,nm:v.s2_nm,c:'#34f06a',bar:'#34f06a',hl:1}].forEach(function(r,i){var chips='';if(i>0&&r.ps>0){chips='<div class="nc-chips"><span class="nc-chip2" style="background:'+ncHexA(r.bar,.16)+';color:'+r.c+'">+'+(r.ps-sp)+' PS</span><span class="nc-chip2" style="background:'+ncHexA(r.bar,.16)+';color:'+r.c+'">+'+(r.nm-sn)+' Nm</span></div>';}var bsh=r.dim?'':';box-shadow:0 0 10px '+ncHexA(r.bar,.55);var d=document.createElement('div');d.className='nc-row'+(r.hl?' hl':'');d.innerHTML='<span class="nc-bar" style="background:'+r.bar+bsh+'"></span><div class="nc-meta"><div class="nc-rl"'+(r.hl?' style="color:rgba(52,240,106,.7)"':'')+'>'+r.l+'</div><div class="nc-rnm">'+(r.nm>0?r.nm+' Nm':'')+'</div></div><div class="nc-right"><div class="nc-rps" style="color:'+r.c+(r.hl?';text-shadow:0 0 18px rgba(52,240,106,.35)':'')+'">'+(r.ps>0?r.ps:'—')+'<i>PS</i></div>'+chips+'</div>';box.appendChild(d);});}
 function ncHoverAt(t){var S=NC_STATE,hov=document.getElementById('nc-cv-hover');if(!S||!hov)return;hov.innerHTML='';var X=S.px(t);hov.appendChild(ncEl('line',{x1:X,y1:S.yT,x2:X,y2:S.yB,stroke:'rgba(255,255,255,.25)','stroke-width':1,'stroke-dasharray':'3,3'}));var rows=S.SR.filter(function(s){return s.ps>0||s.nm>0;}).map(function(s){var pvc=s.ps*ncFrac(NC_PSHAPE,t),tvc=s.nm*ncFrac(NC_TSHAPE,t);if(S.mode!=='torque'&&s.ps>0)hov.appendChild(ncEl('circle',{cx:X,cy:S.pyP(pvc+s.ps*NC_AMP*ncRip(t,s.seed)),r:3.5,fill:s.c,stroke:'#0a0e15','stroke-width':1.5}));if(S.mode!=='power'&&s.nm>0)hov.appendChild(ncEl('circle',{cx:X,cy:S.pyT(tvc+s.nm*NC_AMP*ncRip(t,s.seed+1)),r:3.5,fill:s.c,stroke:'#0a0e15','stroke-width':1.5,'fill-opacity':.85}));return{l:s.l,c:s.c,pv:Math.round(pvc),tv:Math.round(tvc),ps:s.ps};});if(!rows.length)return;var rpm=Math.round((1000+t*6000)/50)*50,bw=S.mode==='both'?206:150,rh=19,bh=30+rows.length*rh+8,left=X>S.x0+S.pW*.55,bx=left?X-bw-14:X+14,last=rows[rows.length-1],ay=last.ps>0?S.pyP(last.pv):S.pyT(last.tv),by=Math.max(S.yT,Math.min(S.yB-bh,ay-bh/2)),g=ncEl('g',{});g.appendChild(ncEl('rect',{x:bx,y:by,width:bw,height:bh,rx:9,fill:'rgba(8,11,16,.96)',stroke:'rgba(52,240,106,.25)','stroke-width':1}));var hd=ncEl('text',{x:bx+13,y:by+19,fill:'rgba(255,255,255,.5)','font-size':10,'font-family':"'DM Mono',monospace"});hd.textContent=rpm.toLocaleString(NC_LOCALE)+' '+T('rpm_short');g.appendChild(hd);rows.forEach(function(r,i){var ry=by+30+i*rh+12;g.appendChild(ncEl('circle',{cx:bx+15,cy:ry-3.5,r:4,fill:r.c}));var lab=ncEl('text',{x:bx+27,y:ry,fill:'rgba(255,255,255,.85)','font-size':11,'font-family':"'DM Mono',monospace"});lab.textContent=r.l+'  '+(S.mode==='power'?r.pv+' PS':S.mode==='torque'?r.tv+' Nm':r.pv+' PS · '+r.tv+' Nm');g.appendChild(lab);});hov.appendChild(g);hov.style.opacity=1;}
 function ncBindHover(){var hit=document.getElementById('nc-cv-hit'),svg=document.getElementById('nc-cv-svg');if(!hit||hit._ncBound)return;hit._ncBound=true;function at(cx){var r=svg.getBoundingClientRect();var t=Math.max(0,Math.min(1,((cx-r.left)*NC_STATE.geo.W/r.width-NC_STATE.x0)/NC_STATE.pW));ncHoverAt(t);}hit.addEventListener('mousemove',function(e){if(NC_STATE)at(e.clientX);});hit.addEventListener('mouseleave',function(){var h=document.getElementById('nc-cv-hover');if(h)h.style.opacity=0;});hit.addEventListener('touchmove',function(e){if(NC_STATE&&e.touches[0])at(e.touches[0].clientX);},{passive:true});hit.addEventListener('touchend',function(){var h=document.getElementById('nc-cv-hover');if(h)h.style.opacity=0;});}
 function renderChart(v,mode,animate){var svg=document.getElementById('nc-cv-svg');if(!svg)return;var G=ncGeo(),x0=G.x0,x1=G.x1,yT=G.yT,yB=G.yB,pW=x1-x0,pH=yB-yT;svg.setAttribute('viewBox','0 0 '+G.W+' '+G.H);var clr=document.getElementById('nc-cv-clip-rect');if(clr){clr.setAttribute('x',x0);clr.setAttribute('y',yT);clr.setAttribute('height',pH);}var hit=document.getElementById('nc-cv-hit');if(hit){hit.setAttribute('x',x0);hit.setAttribute('y',yT);hit.setAttribute('width',pW);hit.setAttribute('height',pH);}var SR=ncSeries(v);function ax6(p,r){var s=Math.ceil((p*1.06/6)/r)*r||r;return{s:s,max:s*6};}var PA=ax6(Math.max(SR[0].ps,SR[1].ps,SR[2].ps,1),25),TA=ax6(Math.max(SR[0].nm,SR[1].nm,SR[2].nm,1),100);var px=function(t){return x0+t*pW;},pyP=function(val){return yB-(val/PA.max)*pH;},pyT=function(val){return yB-(val/TA.max)*pH;};function curve(peak,shape,py,seed){var a=[];for(var n=0;n<46;n++){var t=n/45;a.push([px(t),py(peak*ncFrac(shape,t)+peak*NC_AMP*ncRip(t,seed))]);}return a;}var grid=document.getElementById('nc-cv-grid'),axis=document.getElementById('nc-cv-axis'),gP=document.getElementById('grp-power'),gT=document.getElementById('grp-torque'),peaks=document.getElementById('nc-cv-peaks'),hov=document.getElementById('nc-cv-hover');grid.innerHTML='';axis.innerHTML='';gP.innerHTML='';gT.innerHTML='';peaks.innerHTML='';if(hov)hov.innerHTML='';for(var i=0;i<=6;i++){var y=yB-(i/6)*pH;grid.appendChild(ncEl('line',{x1:x0,y1:y,x2:x1,y2:y,stroke:i===0?'rgba(255,255,255,.13)':'rgba(255,255,255,.045)','stroke-width':1}));var lt=ncEl('text',{x:x0-9,y:y+3,fill:'rgba(255,255,255,.3)','font-size':G.fs,'text-anchor':'end','font-family':"'DM Mono',monospace"});lt.textContent=Math.round(PA.max*i/6);lt.setAttribute('class','ax-p');axis.appendChild(lt);var rt=ncEl('text',{x:x1+9,y:y+3,fill:'rgba(255,255,255,.3)','font-size':G.fs,'text-anchor':'start','font-family':"'DM Mono',monospace"});rt.textContent=Math.round(TA.max*i/6/50)*50;rt.setAttribute('class','ax-t');axis.appendChild(rt);}axis.appendChild(ncEl('line',{x1:x0,y1:yT,x2:x0,y2:yB,stroke:'rgba(255,255,255,.13)','stroke-width':1}));axis.appendChild(ncEl('line',{x1:x1,y1:yT,x2:x1,y2:yB,stroke:'rgba(255,255,255,.13)','stroke-width':1}));var capL=ncEl('text',{x:x0,y:yT-12,fill:'rgba(255,255,255,.45)','font-size':G.cap,'text-anchor':'middle','font-family':"'DM Mono',monospace"});capL.textContent='PS';capL.setAttribute('class','ax-p');axis.appendChild(capL);var capR=ncEl('text',{x:x1,y:yT-12,fill:'rgba(255,255,255,.45)','font-size':G.cap,'text-anchor':'middle','font-family':"'DM Mono',monospace"});capR.textContent='Nm';capR.setAttribute('class','ax-t');axis.appendChild(capR);G.xt.forEach(function(j){var xx=px(j/6);if(j>0&&j<6)grid.appendChild(ncEl('line',{x1:xx,y1:yT,x2:xx,y2:yB,stroke:'rgba(255,255,255,.025)','stroke-width':1}));var xt=ncEl('text',{x:xx,y:yB+20,fill:'rgba(255,255,255,.3)','font-size':G.fs,'text-anchor':'middle','font-family':"'DM Mono',monospace"});xt.textContent=(1000+j*1000).toLocaleString(NC_LOCALE);axis.appendChild(xt);});var capX=ncEl('text',{x:(x0+x1)/2,y:yB+(G.W<500?36:40),fill:'rgba(255,255,255,.24)','font-size':G.fs,'text-anchor':'middle','font-family':"'DM Mono',monospace",'letter-spacing':'.14em'});capX.textContent=T('rpm_axis');axis.appendChild(capX);var topI=(SR[2].ps>=SR[1].ps)?2:1;if(SR[topI].ps>0){var ar=[];for(var m=0;m<46;m++){var tt=m/45;ar.push([px(tt),pyP(SR[topI].ps*ncFrac(NC_PSHAPE,tt))]);}gP.appendChild(ncEl('path',{d:ncSmooth(ar)+' L'+x1+','+yB+' L'+x0+','+yB+' Z',fill:'url(#nc-gArea)',stroke:'none'}));}SR.forEach(function(s){if(s.nm>0){var tl=ncEl('path',{d:ncSmooth(curve(s.nm,NC_TSHAPE,pyT,s.seed+1)),fill:'none',stroke:s.pg,'stroke-width':2,'stroke-dasharray':'7,5','stroke-linecap':'round'});tl.style.opacity=s.dim?.5:.85;gT.appendChild(tl);}});SR.forEach(function(s){if(s.ps>0){var pl=ncEl('path',{d:ncSmooth(curve(s.ps,NC_PSHAPE,pyP,s.seed)),fill:'none',stroke:s.pg,'stroke-width':s.dim?2:3,'stroke-linecap':'round','stroke-linejoin':'round'});if(s.dim)pl.style.opacity=.6;else pl.setAttribute('filter','url(#nc-gl)');gP.appendChild(pl);}});var pkPow=ncEl('g',{}),pkTor=ncEl('g',{});peaks.appendChild(pkTor);peaks.appendChild(pkPow);pkPow.style.transition=pkTor.style.transition='opacity .3s';function pill(grp,x,y,txt,col){var w=txt.length*6.6+16,bx=Math.max(x0,Math.min(x1-w,x-w/2)),by=y-26;grp.appendChild(ncEl('circle',{cx:x,cy:y,r:4.5,fill:col,stroke:'#0a0e15','stroke-width':2,filter:'url(#nc-gl)'}));grp.appendChild(ncEl('rect',{x:bx,y:by,width:w,height:18,rx:9,fill:'rgba(8,11,16,.92)',stroke:col,'stroke-opacity':.5,'stroke-width':1}));var t=ncEl('text',{x:bx+w/2,y:by+12.5,fill:col,'font-size':10,'font-weight':600,'text-anchor':'middle','font-family':"'DM Mono',monospace"});t.textContent=txt;grp.appendChild(t);}if(SR[2].ps>0)pill(pkPow,px(.86),pyP(SR[2].ps),SR[2].ps+' PS','#5dffa0');if(SR[2].nm>0)pill(pkTor,px(.33),pyT(SR[2].nm),SR[2].nm+' Nm','#5dffa0');gP.style.opacity=mode==='torque'?0:1;gT.style.opacity=mode==='power'?0:1;pkPow.style.opacity=mode==='torque'?0:1;pkTor.style.opacity=mode==='power'?0:1;axis.querySelectorAll('.ax-p').forEach(function(e){e.style.opacity=mode==='torque'?.25:1;});axis.querySelectorAll('.ax-t').forEach(function(e){e.style.opacity=mode==='power'?.25:1;});NC_STATE={SR:SR,mode:mode,px:px,pyP:pyP,pyT:pyT,x0:x0,yT:yT,yB:yB,pW:pW,geo:G};NC_BP=ncIsMobile();ncBindHover();ncReveal(animate);}

 /* ═══════════════════════════════════════════════════════════════════════
    VARIANTEN-MATCHING (währungssicher)
    ───────────────────────────────────────────────────────────────────────
    priceCents kommt aus dem Metaobjekt und ist IMMER in Shop-Währung.
    variant.price ist dagegen in der Währung des Besuchers.

    -> Der direkte Cent-Vergleich ist nur in der Shop-Währung gültig.
       In Fremdwährung matcht ausschließlich der Varianten-Titel; der ist
       ein statischer Text (z.B. "699") und ändert sich nie mit.
    Gibt das Varianten-Objekt zurück (nicht nur die ID), damit der Aufrufer
    den echten, von Shopify umgerechneten Preis anzeigen kann.
    ═══════════════════════════════════════════════════════════════════════ */
 function findVariantByPrice(priceCents) {
  var match;
  if (NC_IS_BASE) {
   match = allVariants.find(function(v) { return v.price === priceCents; });
   if (match) return match;
  }
  var priceEur = Math.round(priceCents / 100);
  match = allVariants.find(function(v) { return parseInt(v.title, 10) === priceEur; });
  if (match) return match;
  var priceStr = (priceCents / 100).toFixed(2);
  var priceStrComma = priceStr.replace('.', ',');
  match = allVariants.find(function(v) { var t = v.title.trim(); return t === priceStr || t === priceStrComma || t === priceEur.toString(); });
  if (match) return match;
  return null;
 }
 function fill(el, items, p) {
  el.innerHTML = '<option value="">' + p + '</option>';
  var unique = [];
  items.forEach(function(i) { if (i && unique.indexOf(i) === -1) unique.push(i); });
  unique.sort().forEach(function(i) { var o = document.createElement('option'); o.value = o.textContent = i; el.appendChild(o); });
  el.disabled = unique.length === 0; updateBorder(el);
 }
 function updateBorder(el) { el.classList.toggle('has-value', el.value !== ""); }
 function resetChildSelects(fromLevel) {
  [{el:mS,p:L.model,l:1},{el:eS,p:L.engine,l:2},{el:yS,p:L.year,l:3}].forEach(function(s) {
   if (s.l >= fromLevel) { s.el.innerHTML = '<option value="">'+s.p+'</option>'; s.el.disabled = true; s.el.value = ''; s.el.classList.remove('has-value'); }
  });
 }
 var URL_REGEX = /(https?:\/\/[^\s<>"']+)/i;
 function renderCriticalWarning(brand, model) {
  var banner = document.getElementById('v-critical-banner'); var textEl = document.getElementById('v-critical-text'); var btnEl = document.getElementById('v-critical-btn');
  if (!banner || !textEl || !btnEl) return;
  var raw = getCritical(brand, model);
  if (!raw) { banner.classList.add('nc-hide'); return; }
  var urlMatch = raw.match(URL_REGEX); var displayText = raw;
  if (urlMatch) { var url = urlMatch[1]; displayText = raw.replace(url, '').replace(/\s+[—–-]\s*$/, '').replace(/^\s*[—–-]\s+/, '').trim(); btnEl.href = url; btnEl.classList.remove('nc-hide'); }
  else { btnEl.href = '#'; btnEl.classList.add('nc-hide'); }
  if (!displayText) displayText = L.critical_btn;
  textEl.textContent = displayText; banner.classList.remove('nc-hide');
 }
 function hideCriticalWarning() { var banner = document.getElementById('v-critical-banner'); if (banner) banner.classList.add('nc-hide'); }
 function ytId(u) {
  if (!u) return ''; u = String(u).trim();
  if (u.indexOf('watch?v=') !== -1) return u.split('watch?v=')[1].split('&')[0].split('#')[0];
  if (u.indexOf('youtu.be/') !== -1) return u.split('youtu.be/')[1].split('?')[0].split('&')[0].split('#')[0];
  if (u.indexOf('/embed/') !== -1) return u.split('/embed/')[1].split('?')[0].split('&')[0].split('#')[0];
  if (u.indexOf('/shorts/') !== -1) return u.split('/shorts/')[1].split('?')[0].split('&')[0].split('#')[0];
  return u;
 }

 /* ── Video mit YouTube-Facade (Player lädt erst beim Klick) ─────────── */
 var NC_VID_ID = '';
 var ytWarmed = false;
 function ytWarm() {
  if (ytWarmed) return; ytWarmed = true;
  ['https://www.youtube-nocookie.com','https://i.ytimg.com','https://www.google.com'].forEach(function(h) {
   var l = document.createElement('link'); l.rel = 'preconnect'; l.href = h; document.head.appendChild(l);
  });
 }
 function renderFacade() {
  var wrap = document.getElementById('v-video-wrap'), id = NC_VID_ID;
  if (!wrap || !id) return;
  wrap.innerHTML =
   '<button type="button" class="nc-facade">' +
     '<img class="nc-facade__thumb" width="1280" height="720" loading="lazy" decoding="async" alt="" ' +
          'src="https://i.ytimg.com/vi/' + id + '/sddefault.jpg" ' +
          'onerror="this.onerror=null;this.src=\'https://i.ytimg.com/vi/' + id + '/hqdefault.jpg\';">' +
     '<span class="nc-facade__play" aria-hidden="true">' +
       '<svg viewBox="0 0 68 48" width="68" height="48"><path d="M66.52 7.74c-.78-2.93-2.49-5.41-5.42-6.19C55.79.13 34 0 34 0S12.21.13 6.9 1.55c-2.93.78-4.63 3.26-5.42 6.19C.06 13.05 0 24 0 24s.06 10.95 1.48 16.26c.78 2.93 2.49 5.41 5.42 6.19C12.21 47.87 34 48 34 48s21.79-.13 27.1-1.55c2.93-.78 4.64-3.26 5.42-6.19C67.94 34.95 68 24 68 24s-.06-10.95-1.48-16.26z" fill="#f00"/><path d="M45 24 27 14v20" fill="#fff"/></svg>' +
     '</span>' +
   '</button>';
  var b = wrap.querySelector('.nc-facade');
  b.setAttribute('aria-label', L.play);
  b.addEventListener('pointerover', ytWarm, { once: true, passive: true });
  b.addEventListener('click', playVideo);
 }
 function playVideo() {
  var wrap = document.getElementById('v-video-wrap'), id = NC_VID_ID;
  if (!wrap || !id) return;
  var f = document.createElement('iframe');
  f.className = 'nc-video-frame';
  f.src = 'https://www.youtube-nocookie.com/embed/' + id + '?rel=0&modestbranding=1&autoplay=1&playsinline=1';
  f.title = 'NGM App';
  f.setAttribute('frameborder', '0');
  f.setAttribute('allow', 'accelerometer;autoplay;clipboard-write;encrypted-media;gyroscope;picture-in-picture;web-share');
  f.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
  f.setAttribute('allowfullscreen', '');
  wrap.innerHTML = ''; wrap.appendChild(f);
 }
 function renderVideo(url) {
  var box = document.getElementById('v-video-box');
  if (!box) return;
  NC_VID_ID = ytId(url);
  if (!NC_VID_ID) { hideVideo(); return; }
  box.classList.remove('nc-hide');
  renderFacade();
 }
 function hideVideo() {
  var box = document.getElementById('v-video-box'), wrap = document.getElementById('v-video-wrap');
  if (box) box.classList.add('nc-hide');
  if (wrap) wrap.innerHTML = '';
 }

 function updateViz(){ if(!currentV||!document.getElementById('nc-cv-svg'))return; ncBuildRows(currentV); ncBuildLegend(); renderChart(currentV,activeMode,true); }
 function syncGlobalState() {
  if (currentV && atcBtn.dataset.variantId) { window.__NGM_CONFIGURATOR = { active: true, variantId: parseInt(atcBtn.dataset.variantId, 10), vehicle: currentV.b + ' ' + currentV.m + ' ' + currentV.e + ' (' + yS.value + ')', lic: currentV.lic || '' }; }
  else { window.__NGM_CONFIGURATOR = { active: false, variantId: null, vehicle: '', lic: '' }; }
 }
 fill(bS, data.map(function(d){return d.b;}), L.brand);
 bS.onchange = function() { resetChildSelects(1); updateBorder(bS); resetV(); if(bS.value){fill(mS,data.filter(function(d){return d.b===bS.value;}).map(function(d){return d.m;}),L.model);mS.disabled=false;} };
 mS.onchange = function() { resetChildSelects(2); updateBorder(mS); resetV(); if(mS.value){fill(eS,data.filter(function(d){return d.b===bS.value&&d.m===mS.value;}).map(function(d){return d.e;}),L.engine);eS.disabled=false;} };
 eS.onchange = function() {
  resetChildSelects(3); updateBorder(eS); resetV();
  if(eS.value){ var ys=[]; data.filter(function(d){return d.b===bS.value&&d.m===mS.value&&d.e===eS.value;}).forEach(function(v){var s=Math.min(v.yf,v.yt),e=Math.max(v.yf,v.yt);for(var i=s;i<=e;i++)if(i>1900)ys.push(String(i));}); var u=[]; ys.forEach(function(y){if(u.indexOf(y)===-1)u.push(y);}); fill(yS,u,L.year); yS.disabled=false; }
 };
 yS.onchange = function() {
  updateBorder(yS);
  currentV = data.find(function(d) { return d.b===bS.value&&d.m===mS.value&&d.e===eS.value&&parseInt(yS.value)>=Math.min(d.yf,d.yt)&&parseInt(yS.value)<=Math.max(d.yf,d.yt); });
  if (!currentV) return;
  /* v4.7.2: Fahrzeug bei JEDER Auswahl merken. Vorher stand das nur in
     autoPrefill() — gespeichert wurde also ausschliesslich, was ohnehin
     schon im Speicher lag oder per URL kam. Wer sich manuell durchklickte,
     wurde nie gemerkt; die 24-Stunden-Erinnerung lief damit praktisch leer.
     Darauf baut auch der Abschluss-CTA auf ("Weiter mit deinem Fahrzeug"). */
  try {
   localStorage.setItem('ngm_vehicle', JSON.stringify({
    brand: bS.value, model: mS.value, engine: eS.value, year: yS.value, ts: Date.now()
   }));
  } catch (e) {}
  document.getElementById('v-info-bar').classList.remove('nc-hide');
  document.getElementById('v-sel-name').textContent = currentV.b+" "+currentV.m;
  document.getElementById('v-sel-engine').textContent = currentV.e+" · "+yS.value;
  var matchedVariant = findVariantByPrice(currentV.p);
  /* Preis der gefundenen Variante ist von Shopify korrekt umgerechnet und
     entspricht exakt dem Warenkorb. Nur ohne Variante behelfen wir uns mit
     dem umgerechneten Metaobjekt-Preis. */
  document.getElementById('v-sel-price').textContent =
    matchedVariant ? ncFmt(matchedVariant.price) : ncFmtConverted(currentV.p);
  ncEachAtc(function(b){
   b.disabled=false;
   b.classList.toggle('is-no-match',!matchedVariant);
   b.querySelector('.nc-atc-label').textContent = matchedVariant ? L.addcart : L.pricena;
   b.dataset.variantId = matchedVariant ? matchedVariant.id : '';
  });
  /* Abschluss-CTA unten: Fahrzeug und Preis spiegeln, damit man vor dem
     Klick nicht nach oben scrollen muss, um zu sehen, was man kauft. */
  var ctaBox=document.getElementById('v-cta'),
      ctaName=document.getElementById('v-cta-name'),
      ctaPrice=document.getElementById('v-cta-price');
  if(ctaName) ctaName.textContent=currentV.b+' '+currentV.m+' · '+currentV.e+' · '+yS.value;
  if(ctaPrice) ctaPrice.textContent=document.getElementById('v-sel-price').textContent;
  if(ctaBox) ctaBox.classList.remove('nc-hide');
  /* Sticky-Leiste mitfuellen. Kuerzerer Text als im CTA — die Leiste ist
     einzeilig und schneidet sonst mitten im Motor ab. */
  var stName=document.getElementById('v-sticky-name'),
      stPrice=document.getElementById('v-sticky-price');
  if(stName) stName.textContent=currentV.b+' '+currentV.m+' · '+currentV.e;
  if(stPrice) stPrice.textContent=document.getElementById('v-sel-price').textContent;
  ncStickyApply();
  syncGlobalState();
  var hint=document.getElementById('v-hint');if(hint)hint.classList.add('nc-hide');
  var fGrid=document.getElementById('v-features-grid');
  fGrid.classList.remove('is-open');
  fGrid.innerHTML=currentV.f.map(function(f){return '<div class="nc-feat-item"><div class="nc-feat-ico"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg></div><div class="nc-feat-name">'+f+'</div><div class="nc-feat-status">'+L.active+'</div></div>';}).join('');
  document.getElementById('nc-feat-count').textContent=currentV.f.length+' '+L.count;
  var warnBox=document.getElementById('v-warn-box');
  if(currentV.notes&&currentV.notes.trim().length>1){document.getElementById('v-warn-content').textContent=currentV.notes;warnBox.classList.remove('nc-hide');}else{warnBox.classList.add('nc-hide');}
  document.getElementById('v-features-box').classList.remove('nc-hide');
  renderVideo(currentV.yt_url);
  var tBtn=document.getElementById('v-feature-toggle');
  if(currentV.f.length>4){tBtn.style.display='block';tBtn.textContent=L.showall;}else{tBtn.style.display='none';fGrid.classList.add('is-open');}
  renderCriticalWarning(currentV.b, currentV.m);
  updateViz(); syncProps();
 };
 document.getElementById('v-feature-toggle').addEventListener('click',function(){var g=document.getElementById('v-features-grid');var o=g.classList.toggle('is-open');this.textContent=o?L.showless:L.showall;});
 function syncProps() {
  if(!currentV)return;
  document.querySelectorAll('form[action*="/cart/add"]').forEach(function(form){
   function add(n,v){var i=form.querySelector('input[name="properties['+n+']"]');if(!i){i=document.createElement('input');i.type='hidden';i.name='properties['+n+']';form.appendChild(i);}i.value=v;}
   add('Vehicle',currentV.b+" "+currentV.m+" "+currentV.e+" ("+yS.value+")");
   add('_License Code',currentV.lic||"");
  });
 }
 /* ═══════════════════════════════════════════════════════════════════════
    WARENKORB (v4.4) — identisches Verhalten auf Android, iOS und Windows
    ───────────────────────────────────────────────────────────────────────
    Vorher lief hier ein eigener Fetch, der den Android-Fix aus Cart-Drawer
    v4.7 komplett umging. Drei Ursachen, alle behoben:

      a) cart.js wurde ohne cache:'no-store' und ohne Cache-Buster geholt.
         Android- und Windows-Browser durften die Antwort aus dem Cache
         bedienen — lag dort der Stand von vorher (leerer Warenkorb), zeigte
         der Drawer "Your cart is empty". Im Inkognito nie, weil kein Cache.
      b) Es wurde 'cart:refresh' gefeuert. Impacts _onCartRefresh() holt den
         Drawer per GET ohne Cache-Sperre — dieselbe Ursache ein zweites Mal.
      c) Die POST-Antwort von cart/add.js kann das fertige Drawer-HTML
         mitliefern ('sections'). POST-Antworten werden nie zwischen-
         gespeichert. Das blieb ungenutzt.

    Jetzt: sections anfordern, alles mit no-store + Cache-Buster, und
    'cart:change' MIT cart.sections feuern — der Weg, den Impacts
    _onCartChanged() erwartet. 'cart:refresh' nur noch als Rückfall.
    ═══════════════════════════════════════════════════════════════════════ */
 function ngmCfgRoot() {
  return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
 }
 function ngmCfgDrawer() {
  return document.querySelector('cart-drawer') || document.getElementById('cart-drawer');
 }
 /* v4.6: Die Section-ID ist der Angelpunkt fuer "Warenkorb bleibt leer".
    Ohne sie fordert ngmCfgAddToCart() keine 'sections' an, die Antwort
    enthaelt kein Drawer-HTML, und ngmCfgUpdateAndOpen() faellt auf den
    ungecachten GET des Themes zurueck — genau der, der aus dem Browser-
    Cache einen LEEREN Warenkorb liefern kann. Im privaten Fenster faellt
    das nie auf, weil dort kein Cache existiert.

    Das Attribut section-id kommt aus {{ section.id }} im Drawer-Markup.
    Der Drawer ist bei uns ein SNIPPET — wird es per {% render %} eingebunden,
    ist der section-Kontext nicht vererbt und das Attribut bleibt LEER.
    Deshalb zusaetzlich der Wrapper-Fallback: Shopify verpackt jede Section
    in <div id="shopify-section-<id>">. */
 /* Section, aus der Impact die "hinzugefuegt"-Ansicht rendert. Steht als
    eigene Datei im Theme (sections/variant-added.liquid); der Schluessel in
    cart.sections ist derselbe Name. */
 var NC_SECTION_VARIANT_ADDED = 'variant-added';

 /* Sections additiv an das cart-Objekt haengen. Additiv, weil sie aus zwei
    Quellen kommen koennen: der POST-Antwort von cart/add.js und dem eigenen
    Nachladen der Drawer-Section. Ein einfaches Zuweisen wuerde die jeweils
    andere Quelle ueberschreiben — und damit womoeglich 'variant-added'. */
 function ncMergeSections(cart, sec) {
  if (!cart || !sec) return;
  cart.sections = cart.sections || {};
  for (var k in sec) {
   if (Object.prototype.hasOwnProperty.call(sec, k)) cart.sections[k] = sec[k];
  }
 }

 function ngmCfgSectionId() {
  var d = ngmCfgDrawer();
  if (!d) return '';
  var attr = d.getAttribute('section-id');
  if (attr) return attr;
  var wrap = d.closest ? d.closest('[id^="shopify-section-"]') : null;
  if (wrap && wrap.id) return wrap.id.replace(/^shopify-section-/, '');
  if (!ngmCfgSectionId._warned) {
   ngmCfgSectionId._warned = true;
   console.warn('[NGM] Section-ID des Cart-Drawers nicht ermittelbar — Warenkorb kann aus dem Browser-Cache leer erscheinen.');
  }
  return '';
 }

 /* Legt in den Warenkorb und lässt das Drawer-HTML gleich mitschicken.
    Nutzt window.NGM_CART.add(), falls der Cart-Drawer das bereitstellt —
    sonst die eigene, gleich gehärtete Implementierung. So bleibt der
    Konfigurator unabhängig von der Ladereihenfolge der beiden Dateien. */
 function ngmCfgAddToCart(items) {
  if (window.NGM_CART && typeof window.NGM_CART.add === 'function') {
   return window.NGM_CART.add(items);
  }
  /* v4.6.3: ZWEI Sections anfordern, nicht nur die des Drawers.
     Impacts _onVariantAdded() (theme.js) liest
       event.detail.cart.sections['variant-added']
     — eine eigene Section, die die "hinzugefuegt"-Ansicht rendert. Wir
     hatten immer nur die Drawer-Section angefordert, dieser Schluessel
     fehlte also und es flog:
       can't access property "variant-added", event.detail.cart.sections is undefined
     Der Name 'variant-added' ist der Section-Dateiname im Theme, deshalb
     hier fest verdrahtet. */
  var payload = { items: items };
  var wanted = [];
  var sid = ngmCfgSectionId();
  if (sid) wanted.push(sid);
  wanted.push(NC_SECTION_VARIANT_ADDED);
  payload.sections = wanted;
  payload.sections_url = window.location.pathname;
  return fetch(ngmCfgRoot() + 'cart/add.js', {
   method: 'POST',
   headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
   cache: 'no-store',
   body: JSON.stringify(payload)
  }).then(function(res) {
   if (!res.ok) throw new Error('Cart error ' + res.status);
   return res.json();
  });
 }

 /* Drawer aktualisieren und öffnen. */
 function ngmCfgUpdateAndOpen(addedData) {
  var sid = ngmCfgSectionId();
  var sections = (addedData && addedData.sections) || null;

  return fetch(ngmCfgRoot() + 'cart.js?ts=' + Date.now(), { cache: 'no-store' })
   .then(function(r) { return r.json(); })
   .then(function(cart) {
    /* v4.6.3: Die aus cart/add.js gelieferten Sections IMMER an cart haengen,
       auch wenn die Drawer-Section fehlt — darin steckt 'variant-added', das
       _onVariantAdded() weiter unten braucht. Vorher wurde cart.sections nur
       gesetzt, wenn sec[sid] existierte; fehlte der Drawer, fehlte damit auch
       'variant-added' und der TypeError kam zurueck.
       Der Rueckgabewert sagt nur, ob DRAWER-HTML dabei war.
       Das Feld baseEvent:'variant:add' unten ist reine Nutzlast fuer Impacts
       _onCartChanged, kein Event. */
    function ncEmitChange(sec) {
     ncMergeSections(cart, sec);
     document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
      bubbles: true, detail: { cart: cart, baseEvent: 'variant:add' }
     }));
     return !!(sec && sid && sec[sid]);
    }

    /* Die Sections aus der POST-Antwort vorab uebernehmen. Sie enthalten
       'variant-added' auch dann, wenn die Drawer-Section nicht dabei ist. */
    if (sections) ncMergeSections(cart, sections);

    /* Liefert ein Promise, das erfuellt ist, sobald der Drawer-Inhalt steht.
       WICHTIG: jeder Zweig muss hier durch — das Oeffnen haengt daran. */
    function ncRefreshDrawer() {
     if (sections && sid && sections[sid]) {
      /* Der saubere Weg: Impact rendert aus dem mitgelieferten HTML. */
      return Promise.resolve(ncEmitChange(sections));
     }
     /* v4.6: Rückfall NICHT mehr über 'cart:refresh'. Das löst den GET des
        Themes aus, den wir nicht mit cache:'no-store' versehen können — und
        genau der darf aus dem Browser-Cache einen leeren Warenkorb liefern.
        Stattdessen holen wir das Drawer-HTML selbst, gehärtet. */
     if (sid) {
      var url = window.location.pathname + '?section_id=' + encodeURIComponent(sid) + '&ts=' + Date.now();
      return fetch(url, { cache: 'no-store' })
       .then(function(r) { return r.ok ? r.text() : null; })
       .then(function(html) {
        var s = null;
        if (html) { s = {}; s[sid] = html; }
        return ncEmitChange(s);
       })
       .catch(function() { return ncEmitChange(null); });
     }
     /* Letzter Ausweg, wenn nicht einmal die Section-ID auffindbar ist. */
     document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
     return Promise.resolve(false);
    }

    return ncRefreshDrawer().then(function(hasSections) {
     if (!hasSections) {
      console.warn('[NGM] Drawer ohne Section-HTML aktualisiert — Inhalt kam nur aus cart.js.');
     }
     /* Erst öffnen, wenn der Inhalt steht — _onCartChanged setzt das
        innerHTML in einem setTimeout(0), daher ein kurzer Versatz. */
     setTimeout(function() {
      /* ══════════════════════════════════════════════════════════════════
         v4.6.3 — 'variant:add' wieder aktiv, jetzt mit der richtigen Section
         ──────────────────────────────────────────────────────────────────
         Impacts _onVariantAdded() liest cart.sections['variant-added'].
         Bis v4.6.0 haben wir nur die Drawer-Section angefordert, der
         Schluessel fehlte also — daher der TypeError, der den Listener
         mitten im Aktualisieren abbrechen liess und den Drawer leer stehen
         liess. Seit ngmCfgAddToCart() beide Sections anfordert, ist er da.
         Die Pruefung bleibt trotzdem: liefert Shopify die Section wider
         Erwarten nicht, lassen wir das Event lieber weg, als das Theme
         erneut in denselben Fehler laufen zu lassen. Der Drawer wird
         darunter ohnehin von uns geoeffnet.
         ══════════════════════════════════════════════════════════════════ */
      if (cart.sections && cart.sections[NC_SECTION_VARIANT_ADDED]) {
       document.dispatchEvent(new CustomEvent('variant:add', {
        bubbles: true, detail: { items: addedData.items || [addedData], cart: cart }
       }));
      } else {
       console.warn('[NGM] Section "' + NC_SECTION_VARIANT_ADDED + '" fehlt — variant:add wird uebersprungen.');
      }
      var d = ngmCfgDrawer();
      if (d && typeof d.show === 'function') { d.show(); return; }
      var trigger = document.querySelector('[aria-controls*="cart"][aria-controls*="drawer"]') ||
                    document.querySelector('a[href*="/cart"] .header__cart') ||
                    document.querySelector('.header__icon-wrapper[aria-controls]') ||
                    document.querySelector('[data-action="toggle-mini-cart"]') ||
                    document.querySelector('.cart-toggle') ||
                    document.querySelector('.header a[href="/cart"]');
      if (trigger) trigger.click();
     }, 60);
     return cart;
    });
   });
 }

 /* v4.6: derselbe Handler haengt an BEIDEN Kaufbuttons. Die Zustaende gehen
    ueber ncEachAtc an beide — sonst meldet der geklickte "Hinzugefuegt", der
    andere steht weiter auf "In den Warenkorb". Der Doppelklick-Schutz prueft
    ebenfalls beide, ein zweiter Klick auf den ANDEREN Button waehrend des
    laufenden Requests wuerde sonst doppelt in den Warenkorb legen. */
 function ncAtcClick() {
  if (!currentV) return;
  var useVariantId = parseInt(this.dataset.variantId, 10);
  if (!useVariantId) { alert(L.novariant + ' ' + ncFmtConverted(currentV.p) + '.'); return; }
  if (atcBtns.some(function(b){ return b.classList.contains('is-loading'); })) return;
  ncEachAtc(function(b){ b.classList.add('is-loading'); b.classList.remove('is-highlight'); });

  ngmCfgAddToCart([{
   id: useVariantId,
   quantity: 1,
   properties: {
    'Vehicle': currentV.b + ' ' + currentV.m + ' ' + currentV.e + ' (' + yS.value + ')',
    '_License Code': currentV.lic || ''
   }
  }])
  .then(function(addedData) {
   ncEachAtc(function(b){
    b.classList.remove('is-loading');
    b.classList.add('is-added');
    b.querySelector('.nc-atc-label').textContent = L.added;
   });
   ngmCfgUpdateAndOpen(addedData);
   setTimeout(function() {
    ncEachAtc(function(b){
     b.classList.remove('is-added');
     b.querySelector('.nc-atc-label').textContent = L.addcart;
    });
   }, 2500);
  })
  .catch(function(err) {
   console.error('NGM ATC Error:', err);
   ncEachAtc(function(b){
    b.classList.remove('is-loading');
    b.querySelector('.nc-atc-label').textContent = L.error;
   });
   setTimeout(function() {
    ncEachAtc(function(b){ b.querySelector('.nc-atc-label').textContent = L.addcart; });
   }, 3000);
  });
 }
 ncEachAtc(function(b){ b.addEventListener('click', ncAtcClick); });
 var btnBoth=document.getElementById('btn-both'),btnPower=document.getElementById('btn-power'),btnTorque=document.getElementById('btn-torque');
 function ncSetMode(m,btn){[btnBoth,btnPower,btnTorque].forEach(function(b){if(b)b.classList.remove('on');});btn.classList.add('on');activeMode=m;if(currentV)renderChart(currentV,activeMode,false);}
 if(btnBoth)btnBoth.onclick=function(){ncSetMode('both',this);};
 if(btnPower)btnPower.onclick=function(){ncSetMode('power',this);};
 if(btnTorque)btnTorque.onclick=function(){ncSetMode('torque',this);};
 window.addEventListener('resize',function(){clearTimeout(NC_RZ);NC_RZ=setTimeout(function(){if(!currentV)return;var m=ncIsMobile();if(m===NC_BP)return;NC_BP=m;renderChart(currentV,activeMode,false);},220);});
 function resetV() {
  currentV=null;
  ncEachAtc(function(b){
   b.disabled=true;
   b.classList.remove('is-no-match','is-added','is-loading','is-highlight');
   b.querySelector('.nc-atc-label').textContent=L.addcart;
   b.dataset.variantId='';
  });
  var ctaBox=document.getElementById('v-cta');if(ctaBox)ctaBox.classList.add('nc-hide');
  ncStickyApply();
  document.getElementById('v-info-bar').classList.add('nc-hide');
  document.getElementById('v-features-box').classList.add('nc-hide');
  /* v4.6: #v-warn-box liegt jetzt oben und nicht mehr IN #v-features-box —
     es wird also nicht mehr automatisch mit ausgeblendet. Ohne diese Zeile
     bliebe der Hinweis des vorigen Fahrzeugs stehen. */
  var w=document.getElementById('v-warn-box');if(w)w.classList.add('nc-hide');
  var h=document.getElementById('v-hint');if(h)h.classList.remove('nc-hide');
  clearChart(); hideCriticalWarning(); hideVideo(); syncGlobalState();
 }
 document.addEventListener('submit',function(e){
  if(!document.getElementById('ngm-v-restore-root')||!e.target.action||!e.target.action.includes('/cart/add'))return;
  if(!currentV){e.preventDefault();e.stopImmediatePropagation();alert(L.pleaseselect);return false;}
  syncProps();
 },true);
 function getPrefill() {
  try { var params = new URLSearchParams(window.location.search); var brand = params.get('brand'), model = params.get('model'), engine = params.get('engine'), year = params.get('year'); if (brand && model && engine && year) return { brand: brand, model: model, engine: engine, year: year, source: 'url' }; } catch(e) {}
  try { var raw = localStorage.getItem('ngm_vehicle'); if (raw) { var parsed = JSON.parse(raw); if (parsed && parsed.brand && parsed.model && parsed.engine && parsed.year) { var age = Date.now() - (parsed.ts || 0); if (age < 24 * 60 * 60 * 1000) return { brand: parsed.brand, model: parsed.model, engine: parsed.engine, year: parsed.year, source: 'storage' }; } } } catch(e) {}
  return null;
 }
 function setSelectValue(el, value) { var found = false; for (var i = 0; i < el.options.length; i++) { if (el.options[i].value === value) { found = true; break; } } if (!found) return false; el.value = value; return true; }
 function autoPrefill() {
  var pre = getPrefill(); if (!pre) return;
  if (!setSelectValue(bS, pre.brand)) return; bS.onchange();
  if (!setSelectValue(mS, pre.model)) return; mS.onchange();
  if (!setSelectValue(eS, pre.engine)) return; eS.onchange();
  if (!setSelectValue(yS, pre.year)) return; yS.onchange();
  try { localStorage.setItem('ngm_vehicle', JSON.stringify({ brand: pre.brand, model: pre.model, engine: pre.engine, year: pre.year, ts: Date.now() })); } catch(e) {}
  setTimeout(function() { var bar = document.getElementById('v-info-bar'); if (bar && !bar.classList.contains('nc-hide')) { var rect = bar.getBoundingClientRect(); var inView = rect.top >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight); if (!inView) bar.scrollIntoView({ behavior: 'smooth', block: 'center' }); if (!atcBtn.disabled && !atcBtn.classList.contains('is-no-match')) setTimeout(function() { atcBtn.classList.add('is-highlight'); }, 600); } }, 150);
 }
 if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', autoPrefill); } else { setTimeout(autoPrefill, 50); }
})();